// extracted by mini-css-extract-plugin
module.exports = {"global-section":"Global_global-section__2XZ5E"};